import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField } from "@material-ui/core";
import "./InspectionDialog.css";
import { Formatter, isNullOrEmpty } from "./Util";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

export class InpsectionDialog extends Component {
	constructor(props) {
		super(props);
		this.getData();
		this.state = {
			Elevators: [],
			SelectedElevator: { serial_number: "" },
			InspectionDate: new Date(),
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
		this.selectFile = this.selectFile.bind(this);
		this.delete = this.delete.bind(this);
	}

	componentDidMount() {
		this.getData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.ModalVisible !== prevProps.ModalVisible && this.props.ModalVisible) {
			this.getData();
			var data = this.props.ModalData;
			this.setState({ InspectionsID: data.inspection_reports_id, Description: data.description, InspectionDate: data.date_entered || new Date(), SelectedElevator: data.elevators_id });
		}
	}

	async getData() {
		if (this.props.BuildingID) {
			const data = await fetch("Building/GetElevators", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ buildingsId: this.props.BuildingID }),
			});
			var res = await data.json();
			var el = this.state.SelectedElevator;
			if (typeof el === "string") {
				el = res.filter((ev) => ev.elevators_id.toLowerCase() === el.toLowerCase())[0];
			}
			this.setState({ Elevators: res, SelectedElevator: el });
		}
	}

	selectFile() {
		this.refs.reportUpload.click();
	}

	updateElevator(val) {
		this.setState({ SelectedElevator: val });
	}

	async saveData() {
		var files = this.refs.reportUpload.files;
		if (files && files.length > 0) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var fd = new FormData();
				fd.append("file", file);
				fd.append("bldg", this.props.BuildingID);
				if (this.state.SelectedElevator) {
					fd.append("elevator", this.state.SelectedElevator.elevators_id);
				}

				fd.append("inspectionDate", isNullOrEmpty(this.state.InspectionDate) ? null : Formatter(this.state.InspectionDate, "D"));

				if (!isNullOrEmpty(this.state.Description)) {
					fd.append("description", this.state.Description);
				}

				if (!isNullOrEmpty(this.state.InspectionsID)) {
					fd.append("inspectionsId", this.state.InspectionsID);
				}

				await fetch("Inspection/SaveInspection", {
					method: "POST",
					body: fd,
				});
			}
		} else {
			var fd2 = new FormData();
			fd2.append("bldg", this.props.BuildingID);
			fd2.append("elevator", this.state.SelectedElevator.elevators_id);
			fd2.append("inspectionDate", isNullOrEmpty(this.state.InspectionDate) ? null : Formatter(this.state.InspectionDate, "D"));
			fd2.append("description", this.state.Description || null);
			fd2.append("inspectionsId", this.state.InspectionsID || null);
			await fetch("Inspection/SaveInspection", {
				method: "POST",
				body: fd2,
			});
		}
		this.onClose();
	}

	onClose() {
		this.props.OnClose && this.props.OnClose();
	}

	async delete() {
		if (!window.confirm("Are you sure you want to delete this inspection report?")) return;

		var dt = await fetch("Inspection/Delete", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.state.InspectionsID),
		});

		dt = await dt.text();

		if (!isNullOrEmpty(dt)) {
			alert(dt);
		}
		this.onClose();
	}

	render() {
		var elev = this.state.SelectedElevator;
		if (typeof elev === "string" && this.state.Elevators.length > 0) {
			elev = this.state.Elevators.filter((ev) => ev.elevators_id.toLowerCase() === elev.toLowerCase())[0];
		}
		return (
			<Dialog open={this.props.ModalVisible} onClose={this.onClose} maxWidth="xs">
				<DialogTitle>Inspection Upload</DialogTitle>
				<DialogContent style={{ overflowY: "visible" }}>
					<input type="file" ref="reportUpload" style={{ display: "none" }} onChange={this.SaveFile}></input>
					<Button style={{ width: "48%" }} variant="contained" color="primary" onClick={this.selectFile}>
						Select File
					</Button>
					<Autocomplete
						options={this.state.Elevators}
						getOptionLabel={(option) => option.serial_number}
						style={{ width: "48%", verticalAlign: "top", marginLeft: "4px", display: "inline-block" }}
						selectOnFocus={true}
						onChange={(event, item) => {
							this.updateElevator(item);
						}}
						value={elev}
						renderInput={(params) => <TextField {...params} label="Select an Elevator" size="small" variant="outlined"></TextField>}></Autocomplete>
					<TextField
						style={{ width: "48%", marginTop: "8px" }}
						inputProps={{
							style: {},
						}}
						size="small"
						value={this.state.Description}
						onChange={(event) => this.setState({ Description: event.target.value })}
						label="Description"></TextField>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							size="small"
							style={{ width: "48%", marginLeft: "4px", marginTop: "8px" }}
							autoOk
							variant="inline"
							label="Inspection Date"
							format="MM/dd/yyyy"
							value={this.state.InspectionDate}
							InputAdornmentProps={{ position: "start" }}
							onChange={(date) => {
								this.setState({ InspectionDate: date });
								console.log(date);
							}}
						/>
					</MuiPickersUtilsProvider>
				</DialogContent>

				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
					{this.state.InspectionsID && (
						<Button onClick={this.delete} color="primary">
							Delete
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}
